import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Typography,
  Button,
  Divider,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  dialogWrapper: {
    padding: theme.spacing(2),
    position: "absolute",
    width: "100%",
    maxWidth: "1000px",
    top: theme.spacing(5),
  },
  dialogTitle: {
    padding: "0px",
  },
  cardHeader: {
    color: "rgb(84 110 122)",
  },
  dialogContent: {
    padding: 0,
    border: 0,
  },
}));

export default function Popup(props) {
  const { title, children, openPopup, setOpenPopup } = props;
  const classes = useStyles();

  return (
    <Dialog open={openPopup} classes={{ paper: classes.dialogWrapper }}>
      <DialogTitle className={classes.dialogTitle}>
        <div style={{ display: "flex" }}>
          <Typography
            variant="h4"
            className={classes.cardHeader}
            style={{ flexGrow: 1 }}
          >
            {title}
          </Typography>
          <Button
            color="secondary"
            onClick={() => {
              setOpenPopup(false);
            }}
          >
            <CloseIcon />
          </Button>
        </div>
      </DialogTitle>
      <Divider />
      <DialogContent dividers className={classes.dialogContent}>
        {children}
      </DialogContent>
    </Dialog>
  );
}
